import {useAuth} from "react-oidc-context";
import {ListItem, ListItemButton, ListItemIcon, ListItemText, Menu, MenuItem} from "@mui/material";
import {AccountCircleOutlined, Login} from "@mui/icons-material";
import Box from "@mui/material/Box";
import React, {useState} from "react";

export const UserMenu = () => {
    const auth = useAuth();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = async () => {
        setAnchorEl(null);
        await auth.signoutSilent()
    };

    return (
        <Box>
            <ListItem component="nav">
                {auth.isAuthenticated && <>
                    <ListItemButton onClick={(ev) => handleClick(ev)}>
                        <ListItemIcon
                            aria-label="account of current user"
                            aria-controls="menu-appbar">
                            <AccountCircleOutlined sx={{color: 'white'}}/>
                        </ListItemIcon>
                        <ListItemText>
                            {auth.user?.profile.given_name}
                        </ListItemText>
                    </ListItemButton>
                    <Menu
                        id="user-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={() => setAnchorEl(null)}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}
                    >
                        <MenuItem onClick={handleClose}>Logout</MenuItem>
                    </Menu>
                </>}
                {!auth.isAuthenticated && <ListItemButton onClick={async () => {
                    await auth.signinRedirect()
                }}>
                    <ListItemIcon
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        color="inherit"
                    >
                        <Login sx={{color: 'white'}}/>
                    </ListItemIcon>
                    <ListItemText>Login</ListItemText>
                </ListItemButton>}
            </ListItem>
        </Box>
    )

}